<template>
	<div v-if="mode === 'pc'" :class="buttonClass" @click="handleScrollToTop">
		<SvgIcons name="icon_top" class="c-action-svg" />
		<span class="action-block-span">{{ $t('enterprise.top') }}</span>
	</div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount, inject } from 'vue';

const mode = inject('mode');
// 按钮样式
const buttonClass = computed(() => {
	return ['action-block', { 'action-block--disabled': scrollDisabled.value }];
});

const scrollDisabled = ref(true);
const handleScroll = () => {
	const threshold = 450; // 设置阈值高度，当滚动超过这个高度时切换状态
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	scrollDisabled.value = scrollTop < threshold;
};

// 返回顶部
const handleScrollToTop = () => {
	if (scrollDisabled.value) return;
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});
};

onMounted(() => {
	if (mode === 'pc') {
		handleScroll();
		window.addEventListener('scroll', handleScroll);
	}
});
onBeforeUnmount(() => {
	if (mode === 'pc') {
		window.removeEventListener('scroll', handleScroll);
	}
});
</script>
